/* NATURELEI · Produktkarte: Größe wechseln, Merken, Rückmeldung nach „In die Tasche“ */
(function(){
  if (window.__nlcReady) return; window.__nlcReady = true;
  document.addEventListener('change', function(e){
    var s = e.target.closest && e.target.closest('[data-nlc-v]'); if (!s) return;
    var o = s.options[s.selectedIndex], c = s.closest('[data-nlc]'); if (!o || !c) return;
    var p = c.querySelector('[data-nlc-p]'), k = c.querySelector('[data-nlc-c]'), u = c.querySelector('[data-nlc-u]'), b = c.querySelector('[data-nlc-sale]');
    if (p) p.textContent = o.dataset.p;
    if (k) { k.textContent = o.dataset.c || ''; k.hidden = !o.dataset.c; }
    if (b) b.hidden = !o.dataset.c;
    if (u) u.textContent = o.dataset.u || '';
  });
  function paintFavs(root){
    if (!window.nlxWish) return;
    (root || document).querySelectorAll('[data-nlc]').forEach(function(c){
      var f = c.querySelector('[data-nlc-fav]'); if (!f) return;
      var on = window.nlxWish.has(c.dataset.handle);
      f.classList.toggle('is-on', on); f.setAttribute('aria-pressed', on ? 'true' : 'false');
      f.setAttribute('aria-label', on ? 'Von der Merkliste entfernen' : 'Merken');
    });
  }
  window.nlcInit = function(root){
    paintFavs(root);
    (root || document).querySelectorAll('[data-nlc] product-form').forEach(function(f){
      if (f.__nlc) return; f.__nlc = true;
      f.addEventListener('add-to-cart', function(){
        var b = f.querySelector('.button'); if (!b) return;
        b.classList.add('is-done'); b.textContent = 'In der Tasche ✓';
        setTimeout(function(){ b.classList.remove('is-done'); b.textContent = 'In die Tasche'; var q = f.querySelector('[data-nlc-qty] input'); if (q) q.value = 1; }, 2600);
      });
    });
  };
  document.addEventListener('click', function(e){
    var f = e.target.closest && e.target.closest('[data-nlc-fav]'); if (!f || !window.nlxWish) return;
    e.preventDefault();
    var c = f.closest('[data-nlc]');
    window.nlxWish.toggle({ handle: c.dataset.handle, title: f.dataset.title, url: f.dataset.url, img: f.dataset.img, price: +f.dataset.cents });
  });
  document.addEventListener('nlx:wish', function(){ paintFavs(); });
  /* Stückzahl − 1 + */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-nlc-qty] [data-q]'); if (!b) return;
    e.preventDefault();
    var i = b.parentNode.querySelector('input'); var v = (parseInt(i.value, 10) || 1) + (+b.dataset.q);
    i.value = Math.max(1, Math.min(99, v));
  });
  document.addEventListener('change', function(e){
    var i = e.target.closest && e.target.closest('[data-nlc-qty] input'); if (!i) return;
    var v = parseInt(i.value, 10); i.value = isNaN(v) ? 1 : Math.max(1, Math.min(99, v));
  });
})();
